module.exports = __webpack_public_path__ + "img/ico_scanner.74721cdd.svg";